<template>
  <v-card>
    <v-tabs v-model="selected" background-color="blue-grey lighten-5" right>
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab to="/planoManutencao">Plano manutenção</v-tab>
      <v-tab to="/servicoPlano">Serviço Plano</v-tab>
      <v-tab to="/periodicidade">Peridiocidade</v-tab>
      <v-tab to="/compartimento">Compartimento</v-tab>
      <v-tab to="/planoEquipamento">Plano Equipamento</v-tab>
    </v-tabs>
  </v-card>
</template>
<script>
export default {
  name: "criarPlano",
  data: () => ({
    selected: null,
  }),
  props: {
    active_tab: Object,
  },
  mounted() {
    this.selected = this.active_tab
  },
};
</script>